import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthentificationService } from '../services/authentification.service';
import { RuntimeProfileService } from '../services/RuntimeProfileService';

// Garde partagee FrontOffice / BackOffice.

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private oidcSecurityService: OidcSecurityService,
        private authService: AuthentificationService,
        private router: Router,
        private runtimeProfile: RuntimeProfileService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {
        // Si on est déjà sur la page de callback, laissez passer
        if (state.url.startsWith('/auth-callback')) {
            return of(true);
        }

        // Profil "local" rendu par l'API : acces sans OIDC.
        if (this.runtimeProfile.skipsAuthentication) {
            console.log('[AUTH-GUARD] profil local — acces sans OIDC');
            return of(true);
        }

        return this.oidcSecurityService.isAuthenticated$.pipe(
            map(({ isAuthenticated }) => {
                if (isAuthenticated) {
                    return true;
                }

                this.authService.authorizeWithReturnUrl(state.url);
                return false;
            })
        );
    }
}
